export const formatCurrency = (value: number, currencyCode: string) => {
  const numVal = parseFloat(String(value));
  if (isNaN(numVal)) return value;
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currencyCode,
  }).format(numVal);
};
